/* zenz-for-etter.js
   Drar skillelinjen i for/etter-modulen. Ingen avhengigheter, ingen globale bivirkninger
   utover en enkelt init-flagg-variabel. Fungerer med flere instanser pa samme side og
   re-initialiseres nar Theme Editor laster en seksjon pa nytt.

   <input type="range"> er eneste kilde til posisjon: det gir tastatur (piltaster,
   Home/End, PageUp/PageDown) og skjermleserstotte gratis. Peker-input leses pa ramma
   og skrives tilbake til inputen. */
(function () {
  if (window.__zfeInit) return;
  window.__zfeInit = true;

  function setup(root) {
    if (!root || root.getAttribute('data-zfe-ready') === '1') return;
    var media = root.querySelector('[data-zfe-media]');
    var range = root.querySelector('.zfe__range');
    if (!media || !range) return;
    root.setAttribute('data-zfe-ready', '1');

    var beforeLabel = root.getAttribute('data-zfe-before') || 'Før';
    var ticket = null;
    var dragging = false;
    var pending = false;
    var startX = 0;
    var startY = 0;

    function paint() {
      ticket = null;
      root.style.setProperty('--zfe-pos', range.value + '%');
      range.setAttribute('aria-valuetext', Math.round(range.value) + ' % ' + beforeLabel);
    }

    /* rAF-throttling holder bevegelsen jevn ogsa nar pekeren sender mange events */
    function commit(value) {
      value = Math.max(0, Math.min(100, value));
      range.value = String(value);
      if (ticket === null) ticket = requestAnimationFrame(paint);
    }

    function positionFrom(event) {
      var rect = media.getBoundingClientRect();
      if (!rect.width) return null;
      return ((event.clientX - rect.left) / rect.width) * 100;
    }

    function begin(event) {
      dragging = true;
      pending = false;
      root.classList.add('is-dragging');
      try { media.setPointerCapture(event.pointerId); } catch (err) { /* ikke kritisk */ }
    }

    function end(event) {
      pending = false;
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      try { media.releasePointerCapture(event.pointerId); } catch (err) { /* ikke kritisk */ }
    }

    media.addEventListener('pointerdown', function (event) {
      if (event.button) return;
      startX = event.clientX;
      startY = event.clientY;
      if (event.pointerType === 'mouse') {
        /* Mus: hopp rett til klikkpunktet */
        var value = positionFrom(event);
        if (value === null) return;
        begin(event);
        commit(value);
      } else {
        /* Touch/pen: vent til retningen er kjent, sa vertikal scroll ikke stjeles */
        pending = true;
      }
    });

    media.addEventListener('pointermove', function (event) {
      if (pending) {
        var dx = Math.abs(event.clientX - startX);
        var dy = Math.abs(event.clientY - startY);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { pending = false; return; }
        begin(event);
      }
      if (!dragging) return;
      var value = positionFrom(event);
      if (value === null) return;
      event.preventDefault();
      commit(value);
    });

    media.addEventListener('pointerup', end);
    media.addEventListener('pointercancel', end);
    media.addEventListener('lostpointercapture', end);

    range.addEventListener('input', function () { commit(parseFloat(range.value)); });

    paint();
  }

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll('[data-zfe]');
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* Theme Editor: seksjonen rendres pa nytt uten sidelast */
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
